import React, { useEffect, useState } from 'react'
import { Target } from 'lucide-react'
import api from '../api'
import { Card, PageHeader, Button, Input, Field, Alert } from '../components/ui'

function rp(n) { return 'Rp ' + Number(n || 0).toLocaleString('id-ID') }

export default function TargetKerja() {
  const [target, setTarget] = useState('')
  const [budgetTarget, setBudgetTarget] = useState('')
  const [saving, setSaving] = useState(false)
  const [msg, setMsg] = useState(null)

  useEffect(() => {
    api.get('/target-kerja').then(r => {
      setTarget(r.data.target ?? '')
      setBudgetTarget(r.data.budget_target ?? '')
    })
  }, [])

  async function simpan() {
    setSaving(true); setMsg(null)
    try {
      await api.put('/target-kerja', {
        target: target === '' ? null : Number(target),
        budget_target: budgetTarget === '' ? null : Number(budgetTarget)
      })
      setMsg({ type: 'success', text: 'Target kerja disimpan' })
    } catch (e) {
      setMsg({ type: 'error', text: e.response?.data?.message || 'Gagal menyimpan' })
    } finally { setSaving(false) }
  }

  const ratePerPekerjaan = target && budgetTarget ? Number(budgetTarget) / Number(target) : null

  return (
    <div>
      <PageHeader title="Target Kerja" subtitle="Target jumlah pekerjaan selesai per bulan -- berlaku sama untuk semua teknisi" />
      <div style={{ maxWidth: 420 }}>
        <Card style={{ padding: 22 }}>
          <h2 style={{ fontSize: 14.5, fontWeight: 700, marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 }}>
            <Target size={16} color="var(--brand)" /> Target Bulanan
          </h2>
          <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginBottom: 16 }}>
            Dipakai di halaman Payroll untuk membandingkan realisasi pekerjaan selesai tiap teknisi terhadap target ini, dan sebagai bahan evaluasi kinerja.
          </p>
          {msg && <Alert type={msg.type}>{msg.text}</Alert>}
          <Field label="Jumlah Pekerjaan / Bulan" style={{ marginBottom: 16 }}>
            <Input type="number" value={target} onChange={e => setTarget(e.target.value)} placeholder="mis. 20" />
          </Field>

          <Field label="Budget Bonus Target (Rp)" style={{ marginBottom: 6 }}>
            <Input type="number" value={budgetTarget} onChange={e => setBudgetTarget(e.target.value)} placeholder="mis. 700000" />
          </Field>
          <p style={{ fontSize: 12.5, color: 'var(--text-faint)', marginBottom: 16 }}>
            Anggaran bonus kalau target di atas terpenuhi PENUH. Bonus tiap pegawai di halaman Payroll otomatis terisi proporsional -- realisasi/target x budget ini (dibatasi maksimal segini, tidak lebih walau realisasi melebihi target). Kosongkan salah satu (target atau budget) kalau tidak mau pakai fitur ini -- Bonus tetap manual sepenuhnya seperti biasa.
            {ratePerPekerjaan !== null && <><br /><strong>Rate saat ini: {rp(ratePerPekerjaan)} / pekerjaan selesai.</strong></>}
          </p>
          <Button loading={saving} onClick={simpan}>Simpan</Button>
        </Card>
      </div>
    </div>
  )
}
